import React, { Component } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import { Field } from "redux-form";
import { Check } from "MODULES/shared/components/Forms";
import { dollars } from "LIB/formatters/currency";
import {
  CompanyName,
  NoteTooltip as IconTooltip
} from "APP_ROOT/modules/shared/components";
import NoteTooltip from "MODULES/shared/components/NoteTooltip/NoteTooltip";
import { costAdjLabel } from "MODULES/Commissions/components/Search/Row";

export default class CommissionsTable extends Component {
  static propTypes = {};

  headerRow = () => (
    <tr>
      <th />
      <th />
      <th>Ref #</th>
      <th>Customer</th>
      <th>Source</th>
      <th>Part #</th>
      <th>Serial #</th>
      <th className="text-right">Total Commission</th>
    </tr>
  );

  totalRow = () => (
    <tr style={{ fontWeight: "bold" }}>
      <td>Total Paid</td>
      <td />
      <td />
      <td />
      <td />
      <td />
      <td />
      <td className="text-right">
        {dollars(
          this.props.commissions.reduce(
            (prev, cur) =>
              prev +
              (this.props.selectedCommissions &&
                this.props.selectedCommissions[cur.id] &&
                parseFloat(cur.total_commission)),
            0
          )
        )}
      </td>
    </tr>
  );

  renderRow = (commission, i) => {
    const hasActiveRepair =
      commission.source === "sales_order_line_item" &&
      commission.active_repair_item &&
      commission.inventory.consignment_type &&
      !commission.exchange_sale &&
      !commission.active_repair_item.final_evaluation_approved;

    const depreciationCommission =
      !commission.reference_cost_adj_sales_item_id &&
      commission.cost_adjustment_id;

    return (
      <tr key={i}>
        <td>{i + 1}</td>
        <td className="text-center">
          <div style={{ display: "grid", gridTemplateColumns: "auto 20px" }}>
            <div className="col-md-9">
              <div className="form-group" style={{ marginBottom: "0px" }}>
                <div className="btn-group" data-toggle="buttons">
                  <Field
                    component={Check}
                    name={`commissions[${commission.id.toString()}]`}
                    label="Pay"
                    disabled={hasActiveRepair}
                  />
                </div>
              </div>
            </div>
            {hasActiveRepair && (
              <NoteTooltip
                placement="right"
                note="Please process active repair prior to paying."
                icon="fa-info-circle"
                color="rgba(255, 255, 255, 0.25)"
              />
            )}
            {commission.team_leader && (
              <span>
                <IconTooltip icon="fa-users" note="Team Leader" />&nbsp;&nbsp;
              </span>
            )}
          </div>
        </td>
        <td>
          {_.get(
            commission,
            "sales_order.code",
            _.get(commission, "purchase_order.code")
          )}
        </td>
        <td>
          <CompanyName flattenedCompany={commission} />
        </td>
        <td>{costAdjLabel(commission, depreciationCommission)}</td>
        <td>{commission.part_number}</td>
        <td>{commission.serial_number}</td>
        <td className="text-right">{dollars(commission.total_commission)}</td>
      </tr>
    );
  };

  renderLoadingRow = () => (
    <tr>
      <td />
      <td />
      <td colSpan={6}>Loading...</td>
    </tr>
  );

  render() {
    return (
      <table className="table table-striped table-hover table-numbered">
        <thead>{this.headerRow()}</thead>
        <tbody>
          {this.props.loading
            ? this.renderLoadingRow()
            : this.props.commissions.map(this.renderRow)}
          {this.totalRow()}
        </tbody>
        <thead>{this.headerRow()}</thead>
      </table>
    );
  }
}

CommissionsTable.propTypes = {
  commissions: PropTypes.instanceOf(Object),
  selectedCommissions: PropTypes.instanceOf(Object),
  loading: PropTypes.bool
};



// WEBPACK FOOTER //
// ./app/modules/Commissions/components/PayAll/CommissionsTable.jsx